import * as requestLib from '../lib/requestLib'
import Swal from 'sweetalert2'
import commonMethod from './commonMethod'

let url = window.location.href;
let baseUrl = requestLib.getUrl();

export default {

    checkPermission: (accessToken, callback, errorCallback = () => {})=>{
        return new Promise(function(resolve,reject) {
            if(accessToken) {
                commonMethod.requestGet('api/Group/getUserPayInfo', {userToken: accessToken}, (res) => {

                    // 사용 권한
                    if (!res.data.search_permission) {
                        Swal.fire({
                            showClass:{popup:"swal2-one"},
                            text: 'You don\'t have permission',
                            confirmButtonText: 'OK',
                        }).then(res=>{
                            if(res.value)  window.history.back();
                        });
                        
                    }  else {
                        resolve(res.data.userId)
                    }
    
                })
            } else {
                Swal.fire({
                    showClass:{popup:"swal2-one"},
                    text: 'You don\'t have permission',
                    confirmButtonText: 'OK',
                }).then(res=>{
                    if(res.value) window.history.back();
                });
            }
            
        })
    },

}